import { makeAutoObservable } from 'mobx'
import { toJS } from 'mobx'

import {
  IPopularDirectionsBeket,
  PopularDirectionsBeket,
} from 'shared/api/beket/directions'

class PopularDirectionStore {
  popularDirectionsList: IPopularDirectionsBeket[] | null = null

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  async fetchPopularDirectionsList() {
    try {
      const { data } = await PopularDirectionsBeket.getPopularDestinations()

      this.setPopularDirectionsList(data.data)

      return toJS(this.getPopularDirectionsList())
    } catch (error) {
      console.error('Failed to fetch popular directions:', error)
    }
  }

  setPopularDirectionsList(data: IPopularDirectionsBeket[] | null) {
    this.popularDirectionsList = data
  }

  getPopularDirectionsList() {
    return toJS(this.popularDirectionsList)
  }
}

export const popularDirectionBeketStore = new PopularDirectionStore()
